export default "__VITE_ASSET__CTbuXZMn__"